"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

// Copyright © 2019 The Things Network Foundation, The Things Industries B.V.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var Token = /*#__PURE__*/function () {
  function Token(token) {
    (0, _classCallCheck2["default"])(this, Token);

    /**
     * Make sure it is possible to instantiate an instance
     * of the class only once.
     */
    if (!!Token.instance) {
      return Token.instance;
    }

    if (this.token) {
      return Token.instance;
    }

    Token.instance = this;
    this.token = token;
    return this;
  }

  (0, _createClass2["default"])(Token, [{
    key: "get",
    value: function get() {
      return this.token;
    }
  }]);
  return Token;
}();

var _default = Token;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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